<div class="slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" (focusin)="onFocusIn()" (focusout)="onFocusOut()" tabindex="0">
  <div class="slider-wrapper" [style.transform]="'translateX(' + (-currentIndex * (100 / slidesPerPage)) + '%)'">
    <div class="slide" *ngFor="let slide of displayedSlides; let i = index" (click)="goToDetails(slide)">
      <img [src]="slide.image" alt="Slide Image" class="slide-image">
      <div class="slide-text">
        <h3>{{ slide.text1 }}</h3>
        <p>{{ slide.text2 }}</p>
      </div>
    </div>
  </div>

  <button class="prev-button" (click)="prevSlide()">&#10094;</button>
  <button class="next-button" (click)="nextSlide()">&#10095;</button>

  <div class="slider-dots">
    <span *ngFor="let dotIndex of [].constructor(totalPages); let i = index" 
          [class.active]="i === currentDotIndex" 
          (click)="goToSlide(i)"></span>
  </div>
</div>